import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AdminUserAgent } from "../../../../../api/adminUserAgent";
import { clearState } from "../../../../../reducers/user";
import { resetActiveChoice } from "../../../../../reducers/active-choice";
import { authActions, getTokenFromStorage } from "../../../../../utils";

const useLogout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const logout = async () => {
        const token = getTokenFromStorage();

        try {
            if (token) {
                await AdminUserAgent.logout(token);
            }
        } catch (error) {
            console.error("Failed to logout:", error);
        } finally {
            sessionStorage.clear() 
            authActions.resetLocalStorageAuthData();
            dispatch(clearState());
            navigate("/sign-in");

            setTimeout(() => {
                dispatch(resetActiveChoice());
            }, 1400)

        }
    };

    return logout;
};

export default useLogout;
